import { render, staticRenderFns } from "./ProductAdmin.vue?vue&type=template&id=9a8e7046&scoped=true"
import script from "./ProductAdmin.vue?vue&type=script&lang=js"
export * from "./ProductAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProductAdmin.vue?vue&type=style&index=0&id=9a8e7046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8e7046",
  null
  
)

export default component.exports